import { render, staticRenderFns } from "./mentor.vue?vue&type=template&id=5d123e2c&"
import script from "./mentor.vue?vue&type=script&lang=js&"
export * from "./mentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports